import { styled } from '@mui/material/styles';

import { theme } from 'styles';

// const tagColorMap: Record<string, string> = {
//   untagged: '#f5f5f5',
//   newsfeed: '#f5f5f5',
//   profile: '#f5f5f5',
// };

// const getTagBackground = (tag?: string) => (tag && tagColorMap[tag]) || '#fff';

export const CardW = styled('div', {
  shouldForwardProp: (prop) => prop !== 'tag' && prop !== 'viewMode',
})<{ isManageable?: boolean; viewMode?: string }>`
  height: ${({ viewMode }) => (viewMode === 'list' ? '76px' : '100px')};
  width: 100%;
  min-height: ${({ viewMode }) => (viewMode === 'list' ? '76px' : '100px')};

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: ${({ isManageable }) =>
    isManageable ? theme.palette.white.main : theme.palette.white.p100};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: ${({ viewMode }) => (viewMode === 'list' ? '12px' : '16px')};

  padding: ${({ viewMode }) => (viewMode === 'list' ? '16px' : '16px')};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.palette.info.main};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  }
`;

export const ListMeta = styled('div')`
  flex: 1;
  font-size: 14px;
  color: ${theme.palette.white.grey};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 12px;
`;

export const ListTitle = styled('div')`
  flex: 1.5;
  font-size: 14px;
  font-weight: 600;
  color: ${theme.palette.primary.main};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 12px;
`;

export const CardLeft = styled('div')`
  display: flex;
  align-items: center;
`;

export const IconBox = styled('div')`
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 8px;

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${theme.palette.info.light};

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const CardContent = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 220px;
  min-width: 0;
  margin-left: 12px;
`;

export const TitleText = styled('div')`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SubText = styled('div')`
  font-size: 12px;
  color: ${theme.palette.white.grey};
  line-height: 16px;
`;

export const CardActions = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-left: auto;
`;

export const FolderCardRightW = styled('div')`
  display: flex;
  align-items: center;
  min-width: 42%;
  flex-direction: row;
  margin-left: auto;
`;

export const Description = styled('div')`
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  p {
    margin: 0;
  }
`;

export const BottomSheetHandle = styled('div')`
  width: 36px;
  height: 4px;
  background: ${theme.palette.info.light};
  border-radius: 2px;
  margin: 10px auto 16px;
`;

export const BottomSheetHeader = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px 14px;
`;

export const BottomSheetHeaderText = styled('div')`
  display: flex;
  flex-direction: column;

  span:first-of-type {
    font-size: 14px;
    font-weight: 600;
    color: ${theme.palette.primary.main};
  }

  span:last-of-type {
    font-size: 12px;
    color: ${theme.palette.white.grey};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 220px;
  }
`;
